import { z } from "zod";
export const APP_NAME_DEFAULT = "PGSet";
export const ANSWER_LISTEN_MS = 2000;
export const ANSWER_RETRY_MS = 2000;
export function isListenLocked(answersOpenAtMs, nowMs = Date.now()) {
    return nowMs < answersOpenAtMs;
}
export function isRetryLocked(retryUntilMs, nowMs = Date.now()) {
    return nowMs < retryUntilMs;
}
export const themeSchema = z.object({
    id: z.number(),
    slug: z.string(),
    name: z.string(),
    description: z.string(),
    color: z.string(),
    icon: z.string(),
    active: z.boolean(),
    approvedCount: z.number().optional(),
});
export const LOBBY_ROUND_COUNTS = [5, 10, 20, 30, 40, 50, 75, 100];
export const SOLO_ROUND_COUNTS = [5, 10, 20, 30, 40, 50, 75, 100, 0];
export const lobbySettingsSchema = z.object({
    themeIds: z.array(z.number()).min(0),
    mixRandom: z.boolean(),
    roundCount: z.union([
        z.literal(5),
        z.literal(10),
        z.literal(20),
        z.literal(30),
        z.literal(40),
        z.literal(50),
        z.literal(75),
        z.literal(100),
    ]),
    roundSeconds: z.number().int().min(10).max(120),
});
export const soloConfigSchema = z.object({
    themeIds: z.array(z.number()),
    mixRandom: z.boolean(),
    roundCount: z.union([
        z.literal(5),
        z.literal(10),
        z.literal(20),
        z.literal(30),
        z.literal(40),
        z.literal(50),
        z.literal(75),
        z.literal(100),
        z.literal(0),
    ]),
    roundSeconds: z.number().int().min(10).max(120).optional(),
});
